import { getGenericLabel } from '@com-delta-idp/mnx-skymiles-shared';
import { GenericLabel } from '@com-delta-idp/mnx-utils';
import { TYPE } from '../../models';
import { Tracker as TrackerContent } from '../../models/aem/overview.interface';
import { FutureActivityResponse } from '../../models/api/future-activities.interfaces';
import { LoyaltyMemberTierLevel } from '../../models/api/tracker-details.interfaces';
import { StatusTrackerResponse } from '../../models/api/tracker.interfaces';
import { getThreshold, getTierName, getYear } from './earnometer.utils';

export const getHeader = (
  futureMedallionData: LoyaltyMemberTierLevel,
  aem: TrackerContent
): GenericLabel => {
  return getGenericLabel(
    `${getYear(futureMedallionData.tierLevelStartLocalDate as string)} ${
      aem?.statusProgressLabel
    }`,
    futureMedallionData?.tierLevelCodeDesc || ''
  );
};

export const setInitialData = (
  futureActivities: FutureActivityResponse | undefined,
  api: StatusTrackerResponse
) => {
  const tier = getTierName(
    api.loyaltyMemberTierLevels?.filter(
      (tier) => tier.tierStatusDesc === TYPE.CURRENT
    )
  );

  const pending = (
    futureActivities?.totalFutureBalances
      ? futureActivities.totalFutureBalances.find(
          (balance) => balance.balanceTypeCode === TYPE.MQD
        )?.balanceAmt
      : 0
  ) as number;

  const mqdThreshold = getThreshold(
    api.currentLoyaltyMemberMedallionStatus,
    TYPE.MQD
  );

  const futureMedallionData = api.loyaltyMemberTierLevels.find(
    (tier) => tier.tierStatusDesc === TYPE.FUTURE
  );
  return { futureMedallionData, tier, pending, mqdThreshold };
};
